$(document).ready(function() {
    const menuIcon = $('#menu-icon');
    const mobileMenu = $('#mobile-menu');
    const closeIcon = $('#close-icon');
    const arrows = $('.arrow');
    const arrowBacks = $('.arrow-back');
    const mainMenu = $('#main-menu');
    let activeSubmenu = null;

    menuIcon.click(function() {

        mobileMenu.css('top', '-100%').css('display', 'flex').show().animate({ top: '0' }, 300);
    });

    closeIcon.click(function() {
        mobileMenu.animate({ top: '-100%' }, 500, function() {
            mobileMenu.hide();
            if (activeSubmenu) {
                activeSubmenu.hide();
                mainMenu.show().css('transform', 'translateX(0)');
                activeSubmenu = null;
            }
        });
    });

    arrows.click(function() {
        const targetMenu = $('#' + $(this).data('target'));
        mainMenu.animate({ transform: 'translateX(-100%)' }, 300, function() {
            targetMenu.show().animate({ transform: 'translateX(0)' }, 300);
            activeSubmenu = targetMenu;
        });
    });

    arrowBacks.click(function() {
        const targetMenu = $('#' + $(this).data('target'));
        activeSubmenu.animate({ transform: 'translateX(100%)' }, 300, function() {
            activeSubmenu.hide();
            targetMenu.show().animate({ transform: 'translateX(0)' }, 300);
            activeSubmenu = null;
        });
    });
});